import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=4c3aeea8&scoped=true"
import script from "./accountManage.vue?vue&type=script&lang=js"
export * from "./accountManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3aeea8",
  null
  
)

export default component.exports